
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BooksPage = lazy(() => import('../pages/books/page'));
const FeaturesShortsPage = lazy(() => import('../pages/features-shorts/page'));
const TelevisionPage = lazy(() => import('../pages/television/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/books',
    element: <BooksPage />
  },
  {
    path: '/features-shorts',
    element: <FeaturesShortsPage />
  },
  {
    path: '/television',
    element: <TelevisionPage />
  },
  {
    path: '/news',
    element: <NewsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
